// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset } from "@insite/mobius/GridContainer";
import { listStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListCardList";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

listStyles.wrapper = {};
listStyles.centeringWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: center;
    `,
};

listStyles.cardList = {
    gridContainer: {
        gap: 0,
        css: css`
            padding-bottom: 24px;
            margin-bottom: 8px;

            &[data-test-selector="productListCards_Grid"] {
                border-bottom: 1px solid ${color("common.border")};

                ${xScreen("lte", "xs")} {
                    border-bottom: none;
                }
            }
            ${xScreen("lte", "md")} {
                &[data-test-selector="productListCards_List"] .card_container__wrapper {
                    box-sizing: content-box;
                    &:nth-child(2n-1) {
                        padding-right: 10px;
                    }
                    &:nth-child(2n) {
                        padding-left: 10px;
                    }
                }
            }
        `,
    },
};

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            margin: 0;
            width: 100%;
            padding: 0;
            ${xScreen("lte", "md")} {
                width: calc(50% - 10px);
            }
            ${xScreen("lte", "xs")} {
                width: 100%;
                border-bottom: 1px solid ${color("common.border")};
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            ${xScreen("lte", "md")} {
                height: 100%;
            }
        `,
    },
};

listStyles.cardContainerMultiColumnStyles = {
    cardDivider: {
        css: css`
            border-right: 1px solid ${color("common.border")};
            border-bottom: 0;
            height: 100%;
            padding: 0 18px;
            width: 100%;

            ${xScreen("lte", "md")} {
                padding: 0 11px;
            }
            ${xScreen("lte", "xs")} {
                border-right: 0;
                padding: 0;
            }
        `,
    },
    gridItem: {
        width: [12, 6, 6, 4, 4],
        css: css`
            padding: 12px 0; // override ootb style
            &:last-child {
                > div[class^="sc-"] {
                    border-right: none; /* Remove border right for last row item */
                }
            }
            ${xScreen("gt", "lg")} {
                &:nth-child(3n) {
                    > div[class^="sc-"] {
                        border-right: none; /* Remove border right for last row item */
                    }
                }
            }
            ${xScreen("lte", "md")} {
                max-width: calc(50% - 10px);
                &:nth-child(2n) {
                    > div[class^="sc-"] {
                        border-right: none; /* Remove border right for last row item on tablet*/
                    }
                }
            }
            ${xScreen("lte", "xs")} {
                position: relative;
                max-width: 100%;

                &:after {
                    content: "";
                    position: absolute;
                    width: 100%;
                    left: 0;
                    right: 0;
                    top: 100%;
                    height: 1px;
                    background: ${color("common.border")};
                }
            }
        `,
    },
};
